<!--Item que muestra el nivel del plan(afiliación) para que los usuarios puedan afiliarse y al dar click al botón de "Afiliarme"
    redireccionar al checkout del plan(afiliación)
-->
<template>
  <v-card
    class="white--text text-center rounded fill-height"
    v-if="color"
    :style="'background-color:'+color.background"
  >
    <v-container fluid class="fill-height">
      <v-row justify="center" align="start" class="fill-height">
        <v-col cols="12">
          <v-row justify="center">
            <v-col cols="12" style="height: 80px">
              <h1 class="headline font-weight-bold">{{ tier.name }}</h1>
            </v-col>
            <v-col cols="12" class="display-5 font-weight-bold">
              <p>${{ tier.amount | currency}}</p>
            </v-col>
            <v-col cols="12" class="mt-0" v-if="user.role!='ORGANIZER'">
              <v-row justify="center">
                <v-btn
                  class="black--text font-weight-bold"
                  v-if="color"
                  :style="'background-color:'+color.button"
                  depressed
                  x-large
                  @click="toCheckout()"
                >Afiliarme</v-btn>
              </v-row>
            </v-col>
            <!--
            <v-col cols="12" class="text-center text-sm-left px-2 px-lg-8 pb-0">
              <p v-if="first" class="subtitle-2">
                El nivel
                <span class="font-weight-bold">{{ tier.name }}</span> incluye las siguientes características:
              </p>
              <p v-else class="subtitle-2">
                El nivel
                <span class="font-weight-bold">{{ tier.name }}</span> incluye todo lo del nivel anterior y además:
              </p>
            </v-col>
            -->
            <v-col cols="12" class="text-left px-4 px-lg-8">
              <p v-for="(benefit, index) in tier.benefits" :key="index">
                <v-icon color="white" small left>fas fa-check</v-icon>
                {{ benefit }}
                <br />
              </p>
            </v-col>
            
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapMutations, mapState } from "vuex";

export default {
  props: {
    tier: { type: Object, required: true },
    first: { type: Boolean, required: true },
    color: { type: Object, required: true }
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("user", ["loggedIn", "user"]),
    getLargeSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "font-size:3em";
        case "sm":
          return "font-size:3em";
        case "md":
          return "font-size:4em";
        case "lg":
          return "font-size:6em";
        case "xl":
          return "font-size:7.5em";
      }
    }
  },
  methods: {
    ...mapMutations("affiliation", ["setAffiliationInformation"]),
    toCheckout() {
      this.setAffiliationInformation(this.tier);
      if (this.loggedIn) {
        this.$router.push({ path: `${this.$route.fullPath}/checkout` });
      } else {
        this.$router.push({ path: `/registro/afiliado` });
      }
    }
  }
};
</script>
<style scoped>
.rounded {
  border-radius: 10px;
  border: solid 1px;
}
</style>